<template>
  <div>
    <!-- Main Content of The Page -->
    <main role="main">
      <xb-error-page
        :errorStatus="errorStatus"
        :environment="environment"
        @signOut="signOut"
        @back="goBack"
        @contactUs="contactUs"
      />
    </main>

    <xbase-footer
      title="ACEAS"
      latestUpdate="16 Aug 2020"
      :services="serviceMenu"
      :links="footerAdditionalLinks"
    />
  </div>
</template>

<script>
import Mgr from "./../../services/securityService.js";

const mapGetters = window.Vuex.mapGetters;
const mapState = window.Vuex.mapState;

export default {
  name: "ErrorPages",
  props: {
    errorStatus: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      mgr: new Mgr(this.$store.state.config.configurationData.common_module)
    };
  },
  computed: {
    ...mapState({
      footerAdditionalLinks: state => state.footer.links
    }),
    ...mapGetters({
      serviceMenu: "menus/headers"
    }),
    environment() {
      return this.$store.state.config.configurationData.environment;
    }
  },
  methods: {
    signOut() {
      this.$emit("logout", true);
      this.$store.commit("auth/setIsManuallySignedOut", true);
      this.mgr.signOut().then(
        () => {
          this.setSignedIn(false);
        },
        err => {
          return err;
        }
      );
    },
    goBack() {
      this.$router.push({ path: "/" });
    },
    contactUs() {
      window.location.href = "https://www.cea.gov.sg/contact-info";
    }
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 767px) {
  main {
    padding-top: 59px;
  }
}
</style>